// Analytics helpers that are not part of the dashboard KPI/chart service.
import { apiClient } from "../apiClient";

/** -> { total, averageScore, bySource[], byIntent[], scoreBands[], byStatus[] } or null when the workspace has no leads yet. */
export const getLeadInsights = () => apiClient("/api/analytics/lead-insights").then((res) => res.data);
